import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

export const ScrollToTop = (): void => {
  const { pathname } = useLocation();
  const previousPathname = useRef<string>('');

  useEffect(() => {
    const modalRoutes = ['/my-account'];
    const isCurrentModalRoute = modalRoutes.some((route) => pathname.startsWith(route));
    const wasPreviousModalRoute = modalRoutes.some((route) => previousPathname.current.startsWith(route));

    //store prev pathname
    previousPathname.current = pathname;

    // Don't scroll to top in these cases:
    // 1. Navigating TO a modal route (opening modal)
    // 2. Navigating FROM a modal route (closing modal)
    if (isCurrentModalRoute || wasPreviousModalRoute) {
      return;
    }

    // Only scroll to top for normal page navigation
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 0);
  }, [pathname]);
};
